import { Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatMenu } from "@angular/material/menu";

/**
 * Presentational component for rendering a table row
 * Adds some features for hover / displaying a set of actions
 */
@Component({
    selector: 'app-table-row',
    templateUrl: './table-row.component.html',
    styleUrls: ['./table-row.component.scss'],
})
export class TableRowComponent {

    /**
     * Apply class to host element
     */
    @HostBinding('class.app-table-row')
    tableRowClass = true

    /**
     * Apply class to host element when selected
     */
    @HostBinding('class.app-table-row__selected') 
    get _isRowSelected(): boolean {
        if(this.isHeader) {
            return false
        }
        return this.isSelected
    }

    @HostBinding('class.app-table-row__header') 
    @Input()
    isHeader: boolean = false;

    @HostBinding('class.bottom-line')
    @Input()
    isLast: boolean = false;

    @Input()
    isHeaderSelected: 'no' | 'partial' | 'yes' = 'no';

    @Input()
    selectOption: boolean = false;

    @Input()
    hasOptionalMenuAction: boolean = false;

    @Input()
    optionalMenuAction!: MatMenu

    @Input()
    optionalMenuActionData!: any

    @Output()
    onselectchange = new EventEmitter()

    @Output()
    selectAll = new EventEmitter<boolean>()

    isSelected: boolean = false;

    /**
     * 
     * @param event 
     */
    selectRow(event: MatCheckboxChange) {
        
        // if header select option is checked, emit the checked value to select or unselect all the subsequent rows
        if(this.isHeader) {
            this.isHeaderSelected = event.checked ? 'yes' : 'no'
            this.selectAll.emit(event.checked)
        } else {
            this.isSelected = event.checked
            this.onselectchange.emit()
        }
    }
}